<template>
  <div>
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

// Register necessary Chart.js components
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
  name: 'ColumnChart',
  components: {
    Bar
  },
  data() {
    return {
      chartData: {
        labels: ['month', 'income'],
        // data: [{ name: 'Jan', value: 10 }, { name: 'Feb', value: 20 }],
        datasets: [
          {
            label: 'Stats',
            data: ['25', '20'],
            backgroundColor: '#fa2222'
          },
          {
            label: 'Stats2',
            data: ['5', '3'],
            backgroundColor: '#42A5F5'
          }
        ]
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: {
            position: 'top'
          },
          title: {
            display: true,
            text: 'Column Chart'
          }
        }
      }
    }
  },
  props: {
    data: Object,
    lable: {
        default: "name",
        type: String
    },
    value: {
        default: "value",
        type: String
    },
  },

  // mounted() {
  //   this.fillChartData()
  // },
  // methods: {
  //    fillChartData() {
      

  //       // Example API format: [{ name: 'Jan', value: 10 }, { name: 'Feb', value: 20 }]
  //       this.chartData.labels = this.data.map(item => item.name)
  //       this.chartData.datasets[0].data = this.data.map(item => item.value)
      
  //   }
  // }
}
</script>
